__turbopack_context__.v({
  "error": "PhoneInput-module__c400La__error",
  "phone-input": "PhoneInput-module__c400La__phone-input" + " " + __turbopack_context__.i(232183)["field"],
  "phone-input-container": "PhoneInput-module__c400La__phone-input-container",
});
